import { combineReducers } from 'redux';

import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/interventions/actionTypes';

import { FETCH_KIOSKS_SUCCESS } from 'modules/kiosks/actionTypes';
import { createReducer, sourceMatcher } from 'utils/ReduxUtils';

import details from './details';
import filters from './filters';
import idsByGroup from './idsByGroup';
import movingId from './movingId';

/**
 * @typedef {{
 *   details: import('./details.js').InterventionKanbanDetailsReducer,
 *   filters: import('./filters').KanbanFiltersReducer,
 *   idsByGroup: import('./idsByGroup').KanbanIdsByGroupReducer,
 *   movingId: string,
 *   loading: boolean,
 *   apiError: string,
 * }} KanbanInterventionReducer
 */

export default combineReducers({
  filters,
  details,
  movingId,
  idsByGroup,
  showKioskManagementButton: createReducer(false, {
    [FETCH_KIOSKS_SUCCESS]: sourceMatcher('kanban-dashboard', (_, { payload }) => payload?.content?.length > 0),
  }),
  apiError: error(types.FETCH_KANBAN_INTERVENTIONS),
  loading: loading(types.FETCH_KANBAN_INTERVENTIONS, {
    global: {
      matcher: ({ meta }) => !meta?.silent,
    },
  }),
});
